import WarningIcon from '@mui/icons-material/Warning';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { IConfirmDialog, IDialogFor } from '../../types';
import DraggableComponent from './DraggableComponent';

const ConfirmationDialog = ({
  dialogInfo,
  onConfirmAction,
}: {
  dialogInfo: IConfirmDialog;
  onConfirmAction: (confirmInfo: IDialogFor) => void;
}): ReactElement => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(dialogInfo.open);
  }, []);

  const handleOk = (): void => {
    onConfirmAction({ alertFor: dialogInfo.alertFor, status: true });
    setOpen(false);
  };

  const handleClose = (): void => {
    onConfirmAction({ alertFor: dialogInfo.alertFor, status: false });
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="draggable-dialog-title"
      PaperComponent={DraggableComponent}
      className="common-dialog-style alert-dialog "
    >
      <DialogTitle className="header cursor-move">
        <Grid container sx={{ alignItems: 'center' }}>
          <>
            <WarningIcon color="warning" /> &nbsp;
          </>
          <span> {t(dialogInfo.title)} </span>
        </Grid>
      </DialogTitle>
      <DialogContent className="p-15px align-center ">
        {typeof dialogInfo.description === 'string'
          ? t(dialogInfo.description)
          : dialogInfo.description}
      </DialogContent>
      <DialogActions>
        <Button data-testid="cancel-button" className="text-capitalize" onClick={handleClose}>
          {t('button.cancel')}
        </Button>
        <Button data-testid="ok-button" variant="contained" onClick={handleOk}>
          {t('button.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
